/**
 * The outline is derived from the post's headings at render time, so there is
 * nothing stable to save — editing a heading elsewhere would immediately stale
 * any saved list. render.php is the single source of the frontend markup.
 */
export default function Save() {
  return null;
}
